import { ApplicationTreatmentAction, ApplicationTreatmentActions } from '../actions/applicationTreatments/actions';
import { ApplicationTreatmentsState } from '../actions/applicationTreatments/types/state';

export const initialState: ApplicationTreatmentsState = {
  bySeason: {},
  hasFetched: false,
  isFetching: false,
};

function applicationTreatmentReducer(
  state = initialState,
  action: ApplicationTreatmentActions
): ApplicationTreatmentsState {
  switch (action.type) {
    case ApplicationTreatmentAction.FetchingApplicationTreatments:
      return {
        ...state,
        hasFetched: false,
        isFetching: true,
      };

    case ApplicationTreatmentAction.ReceiveApplicationTreatments:
      return {
        ...state,
        hasFetched: true,
        isFetching: false,
        bySeason: {
          ...action.payload,
        },
      };

    default:
      return state;
  }
}

export default applicationTreatmentReducer;
